import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth/guards/auth.guard';
import { DispersionMethodGuard, ExtendTermGuard, NovationTypeGuard } from '@auth/guards';
import { DataValidationComponent } from './data-validation/data-validation.component';
import { GrayZoneComponent } from './finalDecision/gray-zone';
import { HistoryCreditComponent } from './history-credit/history-credit.component';
import { DecisionModelComponent } from './decision-model';
import { InternalBuroComponent } from './loan/internal-buro/internal-buro.component';
import { ProductValidationsComponent } from './loan/product-validations/product-validations.component';
import { NuevaSolicitudComponent } from './nueva-solicitud/nueva-solicitud.component';
import { SimulatorComponent } from './simulator/simulator.component';
import { ConfirmDateOfIssueComponent } from './finalDecision/confirmDocumentIssue/confirm-date-of-issue.component';

import { ExtendTermComponent } from './extend-term';
import { ValueToPayComponent } from './value-to-pay';
import { PaymentMethodsComponent } from '@home/payment-methods';
import { RenegotiateLoanComponent } from './renegotiate-loan';
import { RapiflexNowComponent } from './rapiflex-now';
import { ApplicationRejectionComponent } from './application-widgets/application-rejection/application-rejection.component';
import { ApplicationTermsAndConditionsComponent } from './application-widgets/application-terms-and-conditions/application-terms-and-conditions.component';
import { CardTermsAndConditionsComponent, CardErrorComponent, CardExplainComponent } from './onboarding-card';
import { SignApplicationComponent } from './finalDecision/sign-application';
import { RefinanceLoanComponent } from './refinance-loan';
import { DispersionMethodComponent } from './dispersion-method';
import { ReferencesComponent } from './references';

const routes: Routes = [
  { path: 'history', component: HistoryCreditComponent, canActivate: [AuthGuard] },
  { path: 'newLoan', component: NuevaSolicitudComponent, canActivate: [AuthGuard] },
  { path: 'simulator', component: SimulatorComponent, canActivate: [AuthGuard] },
  { path: 'dataValidation', component: DataValidationComponent, canActivate: [AuthGuard] },
  { path: 'LoanApplicationRejected', component: ApplicationRejectionComponent, canActivate: [AuthGuard] },
  { path: 'LoanApplicationGrayZone', component: GrayZoneComponent, canActivate: [AuthGuard] },
  {
    path: 'signLoanApplication',
    redirectTo: 'sign-application',
    canActivate: [AuthGuard],
  },
  { path: 'sign-application', component: SignApplicationComponent, canActivate: [AuthGuard] },
  { path: 'internalBuro', component: InternalBuroComponent, canActivate: [AuthGuard] },
  { path: 'productValidations', component: ProductValidationsComponent, canActivate: [AuthGuard] },
  { path: 'decisionModel', redirectTo: 'decision-model' },
  { path: 'decision-model', component: DecisionModelComponent, canActivate: [AuthGuard] },
  { path: 'confirmDateOfIssue', component: ConfirmDateOfIssueComponent, canActivate: [AuthGuard] },
  { path: 'rapiflex-now', component: RapiflexNowComponent, canActivate: [AuthGuard] },
  { path: 'card-terms-and-conditions', component: CardTermsAndConditionsComponent, canActivate: [AuthGuard] },
  { path: 'card-error', component: CardErrorComponent, canActivate: [AuthGuard] },
  { path: 'card-explain', component: CardExplainComponent, canActivate: [AuthGuard] },

  {
    path: 'extend-term/:id',
    component: ExtendTermComponent,
    canActivate: [AuthGuard, ExtendTermGuard, NovationTypeGuard],
  },
  {
    path: 'renegotiate-loan/:id',
    component: RenegotiateLoanComponent,
    canActivate: [AuthGuard, ExtendTermGuard, NovationTypeGuard],
  },
  {
    path: 'value-to-pay/:id',
    component: ValueToPayComponent,
    canActivate: [AuthGuard],
  },
  { path: 'payment-methods', component: PaymentMethodsComponent, canActivate: [AuthGuard] },
  { path: 'application-rejection', component: ApplicationRejectionComponent, canActivate: [AuthGuard] },
  { path: 'application-terms', component: ApplicationTermsAndConditionsComponent, canActivate: [AuthGuard] },
  { path: 'refinance-loan', component: RefinanceLoanComponent, canActivate: [AuthGuard] },
  {
    path: 'dispersion-method',
    component: DispersionMethodComponent,
    canActivate: [AuthGuard, DispersionMethodGuard],
  },
  {
    path: 'references',
    component: ReferencesComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreditRoutingModule {}
